// In local dev the React app (port 3000) and API (port 5001) run separately.
// In production, Express serves both from the same origin.
export const API_BASE =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
    ? "http://localhost:5001"
    : "";
